import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="main-footer" className="bg-helix-dark text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo and Tagline */}
        <div className="flex flex-col items-center mb-12">
          <div className="w-24 h-24 bg-helix-dark border border-white/20 rounded-lg flex items-center justify-center mb-4 overflow-hidden">
            <img 
              src="https://customer-assets.emergentagent.com/job_site-clone-quiz/artifacts/0dzx8831_image.png"
              alt="HelixAspire Logo"
              className="w-16 h-16 object-contain"
            />
          </div>
          <span className="text-2xl font-bold">helixaspire</span>
          <span className="text-xs tracking-[0.2em] uppercase text-white/60 mt-1">
            Innovation. Curiosity. Courage.
          </span>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-6 mb-8">
          <button
            data-testid="footer-services"
            onClick={() => scrollToSection('services')}
            className="text-white/80 hover:text-white transition-colors"
          >
            Services
          </button>
          <button
            data-testid="footer-about"
            onClick={() => scrollToSection('about')}
            className="text-white/80 hover:text-white transition-colors"
          >
            About
          </button>
          <button
            data-testid="footer-biography"
            onClick={() => scrollToSection('founder')}
            className="text-white/80 hover:text-white transition-colors"
          >
            Biography
          </button>
          <button
            data-testid="footer-contact"
            onClick={() => scrollToSection('contact')}
            className="text-white/80 hover:text-white transition-colors"
          >
            Contact
          </button>
          <Link
            data-testid="footer-privacy"
            to="/privacy-policy"
            className="text-white/80 hover:text-white transition-colors"
          >
            Privacy Policy
          </Link>
          <Link
            data-testid="footer-terms"
            to="/terms-and-conditions"
            className="text-white/80 hover:text-white transition-colors"
          >
            Terms and Conditions
          </Link>
          <Link
            data-testid="footer-osint"
            to="/osint-disclaimer"
            className="text-white/80 hover:text-white transition-colors"
          >
            OSINT Disclaimer
          </Link>
        </nav>

        {/* Divider */}
        <div className="w-24 h-px bg-white/20 mx-auto mb-8"></div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-white/60 text-sm">
            &copy; 2026 HelixAspire. All rights reserved.
          </p>
          <p className="text-white/40 text-xs mt-2 tracking-wider">
            INNOVATION. CURIOSITY. COURAGE.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
